define.alias("shared/modifiers/animate-typewriter", "calendar/modifiers/animate-typewriter");